import { useEffect } from 'react'

export const useDynamicTitle = () => {
  useEffect(() => {
    const environment = process.env.REACT_APP_STATUS_ENV

    if (environment && environment.toLowerCase() !== 'prod') {
      const envTitle = environment.charAt(0).toUpperCase() + environment.slice(1)
      const appName = `${envTitle} Trackgood App`

      document.title = appName

      const metaAppName = document.querySelector('meta[name="application-name"]')

      if (metaAppName) {
        metaAppName.setAttribute('content', appName)
      }

      const metaAppleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]')

      if (metaAppleTitle) {
        metaAppleTitle.setAttribute('content', appName)
      }
    }
  }, [])
}
